import { IMunicipalityConfig } from "../common/config/municipalityConfig";
import dataApi from "./dataApiSlice";

const configApi = dataApi.injectEndpoints({
    endpoints: build => ({
        configData: build.query<IMunicipalityConfig, string>({
            query: (municipalityName) => ({
                url: 'config?domain=minside&key=' + municipalityName.toLowerCase(),
            })
        })
    })
});

export const { useConfigDataQuery } = configApi;